import React from 'react';

import { DatabaseOutlined, InboxOutlined } from '@ant-design/icons';
import { Card, Typography } from 'antd';

import { ASSET_TYPES } from '@/shared/api/openmetadata';

import styles from './TotalDataAssets.module.css';

const { Title, Text } = Typography;

type AssetTypeCount = {
  type: string;
  count: number;
};

type TotalDataAssetsProps = {
  totalCount: number;
  assetTypeCounts?: AssetTypeCount[];
  isLoading?: boolean;
};

const getAssetIcon = (type: string) => {
  switch (type) {
    case ASSET_TYPES.DATABASE:
      return <DatabaseOutlined className={styles.assetIcon} />;
    case ASSET_TYPES.CONTAINER:
      return <InboxOutlined className={styles.assetIcon} />;
    default:
      return <DatabaseOutlined className={styles.assetIcon} />;
  }
};

const getAssetLabel = (type: string) => {
  switch (type) {
    case ASSET_TYPES.DATABASE:
      return '데이터베이스';
    case ASSET_TYPES.CONTAINER:
      return '버킷';
    default:
      return type;
  }
};

export const TotalDataAssets: React.FC<TotalDataAssetsProps> = ({
  totalCount,
  assetTypeCounts = [],
  isLoading = false,
}) => {
  return (
    <div className={styles.totalDataAssets}>
      <Title level={4} className={styles.sectionTitle}>
        전체 데이터 자산 ({totalCount.toLocaleString()}개)
      </Title>
      <Card className={styles.totalCard} loading={isLoading}>
        {assetTypeCounts.length > 0 && (
          <>
            <div className={styles.assetTypeList}>
              {assetTypeCounts.map((asset) => (
                <div key={asset.type} className={styles.assetTypeItem}>
                  <div className={styles.assetTypeLeft}>
                    {getAssetIcon(asset.type)}
                    <Text className={styles.assetTypeLabel}>{getAssetLabel(asset.type)}</Text>
                  </div>
                  <Text className={styles.assetTypeCount}>{asset.count.toLocaleString()}</Text>
                </div>
              ))}
            </div>
          </>
        )}
      </Card>
    </div>
  );
};
